import { render, staticRenderFns } from "./FigureQA.vue?vue&type=template&id=0655d4ba&"
import script from "./FigureQA.vue?vue&type=script&lang=js&"
export * from "./FigureQA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports